<template>
  <div>
    <div class="vx-row">
      <div class="vx-col w-full">
        <ul class="heading-ul mb-3">
          <li>
            <router-link :to="{ name: 'Pre Plan' }" class="">
              <feather-icon icon="ArrowLeftIcon" svgClasses="text-dark" />
            </router-link>
          </li>
          <li>
            <h3>
              <td>{{ $route.params.product.productCode }}</td>
            </h3>
          </li>
        </ul>
      </div>
      <div class="vx-col md:w-full lg:w-full sm:w-full w-full mb-base">
        <vx-card>
          <div class="vx-row">
            <div class="vx-col w-full md:w-full lg:w-full">
              <ul class="horizontal-sm-btn flex mb-2 float-right">
                <li>
                  <div
                    class="p-1 cursor-pointer flex items-center text-lg font-medium w-full"
                  >
                    <vs-button
                      color="primary"
                      icon-pack="feather"
                      icon="icon-edit-2"
                      class="truncate"
                      @click="editChannelMapping(id)"
                      size="small"
                      >{{ $t("setup.label.Edit") }}</vs-button
                    >
                  </div>
                </li>
              </ul>
            </div>
          </div>

          <div class="vx-row">
            <div class="w-full">
              <div class="block overflow-x-auto">
                <table class="table w-full table-bordered table-striped">
                  <tr>
                    <td>
                      <b>{{ $t("setup.label.Id") }}</b>
                    </td>
                    <td>
                      <b>{{ $t("setup.label.ChannelName") }}</b>
                    </td>
                  </tr>
                  <tr
                    v-for="(
                      Broadcaster, index
                    ) in productMappingData.selectedChannels"
                    :key="index"
                  >
                    <td>{{ Broadcaster.id }}</td>
                    <td>{{ Broadcaster.channelName }}</td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
        </vx-card>
      </div>
    </div>
  </div>
</template>
<script>
import vSelect from "vue-select";
import { mapState } from "vuex";
import moment from "moment";
export default {
  data() {
    return {
      editJobsPopup: false,
      delId: 0,
      redirectToEdit: false,
      updateCraditPopup: false,
      jobsParameterPopup: false,
    };
  },
  components: {
    "v-select": vSelect,
  },
  computed: {
    ...mapState({
      productMappingData: (state) => state.broadcaster.productMappingData,
      formattedDate: (state) => state.settings.selectedDateFormat,
    }),
  },
  methods: {
    getDate(date) {
      return moment(date).format(this.formattedDate);
    },
    editChannelMapping() {
      this.$router.push({
        name: "Edit Product Mapping",
        params: { id: this.$route.params.id },
      });
    },

    async getChannelMappingById() {
      try {
        await this.$store.dispatch(
          "broadcaster/setProductMappingById",
          this.$route.params.id
        );
      } catch (e) {
        this.$toasted.error(e.message);
      }
    },
  },
  mounted() {
    this.getChannelMappingById();
  },
};
</script>
<style scoped>
.table {
  width: 100%;
  max-width: 100%;
  margin-bottom: 20px;
  background-color: #fff;
  border: solid 1px #f0f0f0;
}

.table td {
  vertical-align: middle;
  border-top: none;
  padding: 10px 7px;
  font-size: 14px;
  color: #646a71;
  border-bottom: 1px solid #dfe3e7;
  transition: all 0.2s ease;
  overflow: hidden;
  word-break: break-all;
}
</style>
